import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";

const VisitorLoginVM = () => {
  const { handleToastOpen } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetOtp, setResetOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetStep, setResetStep] = useState(1); // 1: Enter email, 2: Enter OTP, 3: Set new password
  
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      handleToastOpen("error", "Please enter both email and password.");
      return;
    }

    const loginData = { username: email, password };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BE_URL2}/visitor-mgmt/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        localStorage.setItem("userRole", result.role);
        localStorage.setItem("token", result.token);
        localStorage.setItem("contactInfo", result.email);

        const redirectUrl = localStorage.getItem("redirectAfterLogin");
        localStorage.removeItem("redirectAfterLogin");

        if (result.role === "Admin") {
          navigate("/visitor-mgmt/admin-dashboard");
        } else if (result.role === "Approver") {
          navigate(redirectUrl || "/visitor-mgmt/approver-dashboard");
        } else if (result.role === 'SuperAdmin'){
          navigate("/visitor-mgmt/super-admin-dashboard")
        } 
        else {
          navigate(redirectUrl || "/visitor-mgmt/dashboard");
        }

        handleToastOpen("success", "Login successful!");
      } else {
        handleToastOpen("error", result.message || "Login Failed");
      }
    } catch (error) {
      handleToastOpen("error", "An error occurred. Please try again later.");
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Forgot Password functionality
  const openForgotPassword = () => {
    navigate("/visitor-mgmt/forgot-password");
  };

  const handleSendResetOtp = async () => {
    if (!resetEmail) {
      handleToastOpen("error", "Please enter your email address");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BE_URL2}/visitor-mgmt/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: resetEmail }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setResetStep(2);
        handleToastOpen("success", "OTP sent to your email");
      } else {
        handleToastOpen("error", result.message || "Failed to send OTP");
      }
    } catch (error) {
      handleToastOpen("error", "An error occurred. Please try again later");
    }
  };

  const handleVerifyResetOtp = async () => {
    if (!resetOtp) {
      handleToastOpen("error", "Please enter the OTP sent to your email");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BE_URL2}/visitor-mgmt/verify-reset-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: resetEmail, otp: resetOtp }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setResetStep(3);
        handleToastOpen("success", "OTP verified successfully");
      } else {
        handleToastOpen("error", result.message || "Invalid OTP");
      }
    } catch (error) {
      handleToastOpen("error", "An error occurred. Please try again later");
    }
  };

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      handleToastOpen("error", "Please enter and confirm your new password");
      return;
    }

    if (newPassword !== confirmPassword) {
      handleToastOpen("error", "Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      handleToastOpen("error", "Password must be at least 6 characters long");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BE_URL2}/visitor-mgmt/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: resetEmail,
            otp: resetOtp,
            password: newPassword,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        handleToastOpen("success", "Password reset successfully");
        navigate("/visitor-mgmt/login");
      } else {
        handleToastOpen("error", result.message || "Failed to reset password");
      }
    } catch (error) {
      handleToastOpen("error", "An error occurred. Please try again later");
    }
  };

  return {
    email,
    password,
    showPassword,
    resetEmail,
    resetOtp,
    newPassword,
    confirmPassword,
    resetStep,
    handleEmailChange,
    handlePasswordChange,
    handleLogin,
    togglePasswordVisibility,
    openForgotPassword,
    setResetEmail,
    setResetOtp,
    setNewPassword,
    setConfirmPassword,
    handleSendResetOtp,
    handleVerifyResetOtp,
    handleResetPassword
  };
};

export default VisitorLoginVM;